import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberInviteActivationPage from "@/pages/member/MemberInviteActivationPage";

export const Route = createFileRoute("/member_/invite/activate")({
  head: () => pageHead("Activate Your Member Setup", "Securely activate your AI Innovation Network setup link.", "/member/invite/activate", true),
  component: MemberInviteActivationPage,
});
